import SecondaryButton from "../../Buttons/SecondaryButton";
import PropTypes from "prop-types";

const CalendarToolbar = ({ onNavigate, label, onPrev, onToday, onNext }) => {
  if (!onNavigate) {
    console.warn("onNavigate prop is missing in CalendarToolbar");
    return null;
  }

  return (
    <div className="flex flex-row my-4">
      <div>
        <SecondaryButton
          className="mr-4"
          onClick={() => {
            onNavigate("PREV");
            onPrev();
          }}
        >
          &lt;
        </SecondaryButton>
        <SecondaryButton
          className="mr-4"
          onClick={() => {
            onNavigate("TODAY");
            onToday();
          }}
        >
          Hoy
        </SecondaryButton>
        <SecondaryButton
          className=""
          onClick={() => {
            onNavigate("NEXT");
            onNext();
          }}
        >
          &gt;
        </SecondaryButton>
      </div>
      <div className="flex flex-1 flex-row justify-center items-center">
        {label}
      </div>
    </div>
  );
};

CalendarToolbar.propTypes = {
  onNavigate: PropTypes.func.isRequired,
  label: PropTypes.string,
  onPrev: PropTypes.func.isRequired,
  onToday: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default CalendarToolbar;
